<template lang="pug">
.admin-visit-log
  .blue-gradient.px-4.py-4
    .d-flex.justify-content-between.align-items-center.px-3
      .d-flex(style='z-index: 1')
        .text-xlarge.bold ประวัติการเข้าเยี่ยมวันที่
        CustomDatePicker.ml-3(v-model='filterDate')
      .amount.rounded-circle
        template(v-if="listData.length < 100") {{listData.length}}
        template(v-else) 99+
    //- hr.m-0

  //- template(v-if='isSubmitted === false')
  .img-grid.d-flex.flex-wrap.px-4.pt-1.pb-4
    template(v-for='data in listData')
      .card.shadow.d-flex.flex-column.align-items-center.w-custom-33.mx-2.mb-4(
        style="width: 30%; height: 296px;")
        template(v-if="data.image_path !== null")
          img.check-in-img(
            :src="$api.basePath.replace('api', 'storage') + data.image_path"
            style="max-height: 200px;"
          )
        template(v-else)
          LMap(
            :zoom="15"
            :center="$latLng(data.latitude, data.longitude)"
            style="height: 200px; z-index: 2;"
            :options=`{
              zoomControl: false,
              dragging: false,
              boxZoom: false,
              trackResize: false,
              doubleClickZoom: false,
            }`
          )
            LTileLayer(
              url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            )
            LMarker(
              :lat-lng="$latLng(data.latitude, data.longitude)")
        .text-small.mt-3(style='width: 80%')
          //- template(v-if='data.user')
          //-   .text-medium
          //-     i.fa.fa-user
          //-     span.ml-2 {{ data.user.name }}
          .d-flex.justify-content-between
            span
              | {{ $moment(data.created_at).format('DD/MM/YY') }}
            span
              | {{ $moment(data.created_at).format('HH:mm') }}
          div
            template(v-if="data.latitude !== null")
              | {{parseFloat(data.latitude).toFixed(6)}},
              |
              | {{parseFloat(data.longitude).toFixed(6)}}
      //- template(v-for='i in [0,1,2,3,4,5,6,7,8]')
      //-   img.check-in-img(:src='`http://placekitten.com/${128+(8*i)}/${128+(8*i)}`')

    //- button.btn.btn-upa-secondary.mx-auto.mb-2(@click='submitLocation')
    //-   | บันทึก

  //- template(v-else)
  //-   .submitted.d-flex.flex-column
  //-     .response-message
  //-       img(src='@/assets/icons/success.svg')
  //-       .text-large.mt-3
  //-         | คุณอัพโหลดภาพสำเร็จแล้ว

</template>

<script>
export default {
  props: {
    seller: {
      default: () => ({}),
    },
  },
  watch: {
    seller() {
      this.loadData();
    },
    filterDate() {
      this.loadData();
    },
  },
  data: () => ({
    isSubmitted: false,
    filterDate: '',

    listData: [],
  }),
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.isLoading = true;

      const res = await this.$api.admin.sellerRecords.getCheckins(
        this.seller.id, { ...this.filterDate },
      );

      if (res.status === 200) {
        this.listData = res.data;
      }

      this.isLoading = false;
    },
    submitLocation() {
      // TODO: actually implement the submitting part
      this.isSubmitted = true;
    },
  },
};
</script>

<style lang="scss">
.admin-visit-log {
  // .blue-gradient {
  //   &::before {
  //     z-index: -1;
  //   }
  // }
}
.amount {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 64px;
  width: 64px;
  background: #0092C9;

  font-size: 32px;
  color: #fff;
}

.response-message {
  min-height: 360px;
  background: #FAFAFA;

  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;
}
</style>
